/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as eventPnLReportService from '../services/eventPnLReportService'
import EventPnLReportMarketOrderModel from './sub_components/eventPnLReportMarketOrderModel'
import * as userService from '../services/userService'
import Autocomplete from 'react-autocomplete';
import Currency from './sub_components/currency'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import * as _ from 'lodash'
import * as dateUtil from '../util/date.util'
import { BASE_IMAGE_PATH_NEW } from '../configs/api';
import moment from 'moment';

let linkClickTimeout
let printClickTimeout
class EventPnLReport extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         user_id: '',
         usersList: [],
         client_id: "",
         sportType: "",
         search: '',
         accounts: '',
         eventPnL_data: [],
         eventDic:{},
         csv_json: [],
         pdf_json: [],
         from: "",
         to: "",
         records_display: 100,
         toastMsg: "",
         toastType: "",
         showData: false,
         loader: false,
         selectedMarketList: null,
         onShowOrderPopup: false,

        
         pageLimit: 25,
         pageActive: 1,
         page_no: 1, 
         ePnL_data: [],
         allData: false,
        
      };
   }
   async componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if (!(!!userData && !!userData.sub)) {
         localStorage.clear();
         window.location.href = window.location.origin + "/auth"
      }
      this.setState({ user_id: userData.sub })
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ to: curDate, from: weekDate })
   }
   componentWillUnmount(){
      clearTimeout(linkClickTimeout)
      clearTimeout(printClickTimeout)
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   parseFilterBody() {
      let body = {
         "userId": this.state.client_id,
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
         "eventIds": []
      }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      this.setState({
         eventPnL_data: [],
         showData: true,
         loader: true
      },()=>{
            eventPnLReportService.postMarketPnl(body).then((res) => {
               if (res.isSuccess) {
                     self.setState({
                        eventPnL_data: this.sortMarketData(res.items),
                        eventDic: res.events,
                        loader: false
                     })
               } else {
                  this.setState({ eventPnL_data: [], eventDic:{}, showData: true, loader: false })
               }
            })
         })
   }

   sortMarketData(unSortedArray){
      let sortedArray = [];
      const sortSequence = ['4','1','2','7','4339','400','500','300'];
      if(!!unSortedArray && unSortedArray.length > 0){
         for(let evntTypeId of sortSequence){
            if(JSON.stringify(unSortedArray).indexOf(`"eventTypeId":"` + evntTypeId + `"`) > -1){
               for(let itm of unSortedArray){
                  if(itm.eventTypeId === evntTypeId){
                     // debugger
                     sortedArray.push(itm);
                  }
               }  
            }
         }
      }
      return sortedArray;
   }

   async onDownload(alldata = false) {
      const self = this;
      const eventPnL_data = this.filterEventPnLListWithGrouping()
      this.setState({ csv_json: [] }, () => {
         // let trans = this.state.eventPnL_data
         let trans = Object.values(eventPnL_data.groupData)
         let dictinory = {}
         let balance = ""
         let items = []
         let i = 0
         let filter_user_id = this.state.user_id
        
         for (let x of trans) { 
            if (alldata ? true :(i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)))){ 
               let dictinory = {}
               dictinory["SportType"] = x["eventTypeName"]
               dictinory["Competition"] = x["competitionName"]
               dictinory["Event"] = `${x["eventId"]} - ${x["eventName"]} - ${x["eventDate"]}`
               dictinory["Order Count"] = x["orderCount"]
               dictinory["Total Amount	"] = x["totalAmount"]             
               dictinory["P/L"] = x["pnl"]             
                         
               items.push(dictinory)
            }
            i += 1
         }
       
         this.setState({ csv_json: items }, () => {
            linkClickTimeout = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)

         })
      })
   }
   async onPDFDownload(allData = false) {
      const eventPnL_data = this.filterEventPnLListWithGrouping()
      this.setState({ pdf_json: [] }, () => {
         this.setState({ pdf_json: Object.values(eventPnL_data.groupData), allData: allData }, () => {
            printClickTimeout = setTimeout(function () {
               printJS({
                  printable: 'printJS-div',
                  type: 'html',
                  targetStyles: ['*']
               })
            }, 500)
         })
      })
   }
   


   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   onShowOrderPopup(selectedMarketList, pnl, stakes, orderCnt) {
      const sortedselectedMarketList = selectedMarketList.sort((a, b) => b.orderCount - a.orderCount);
      this.setState({ onShowOrderPopup: true, selectedMarketList: {marketList: sortedselectedMarketList , totalPnL: pnl, totalStakes:stakes, totalOrderCnt:orderCnt}})
   }
   onHideOrderPopup() {
      this.setState({ onShowOrderPopup: false, selectedMarketList: null })
   }
   resetForm() {
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ from: weekDate, to: curDate, accounts: "", usersList: [], client_id: "", sportType: "", search: '', showData: false, eventPnL_data: [] })
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 31) {
         this.props.notify("Date range must be 1 month.", "error");
      }
      else {
         this.setState({ accounts: this.state.client_id, sportType: "", search: '',  pageActive: 1 }, () => { this.submitForm(); });
      }
   }


   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value, pageActive: 1 });
   }
   onSearch(e) {
      let ePnLData = this.state.ePnL_data
      this.setState({ search: e.target.value, ePnL_data: [], pageActive: 1 }, () => {
         this.setState({ ePnL_data: ePnLData })
      })
   }

   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.user_id, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function(a, b) {
             if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
             if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
             return 0;
         });
         this.setState({ usersList: lst })
      }
      else {
         this.setState({ [name]: value, usersList: [] })
      }
   }
   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d })
   }

   filterEventPnLListWithGrouping(){
      let filteredGroupedData = {
         groupData : {},
         totatOrderCount : 0,
         totalPnl : 0,
         totalStakes : 0
      }
      let totatOrderCount = 0
      let totalPnl = 0
      let totalStakes = 0
      for(let mkt of this.state.eventPnL_data){
         if((this.state.search === '' || JSON.stringify(mkt).toLowerCase().indexOf(this.state.search) > -1) && (this.state.sportType === '' || (this.state.sportType.indexOf('99') > -1 ? (this.state.sportType.toLowerCase().indexOf(mkt.provider.toLowerCase()) > -1) : (this.state.sportType === mkt.eventTypeId)))){
            let foundObj = filteredGroupedData.groupData[`k${mkt.eventId.toString()}`];
            if(!!foundObj){
               const torderCount = filteredGroupedData.groupData[`k${mkt.eventId.toString()}`].orderCount + mkt.orderCount;
               filteredGroupedData.groupData[`k${mkt.eventId.toString()}`].orderCount = torderCount;
               filteredGroupedData.groupData[`k${mkt.eventId.toString()}`].pnl += mkt.pnl;
               filteredGroupedData.groupData[`k${mkt.eventId.toString()}`].totalAmount += mkt.totalAmount;
               filteredGroupedData.groupData[`k${mkt.eventId.toString()}`].markets.push(mkt);
            }  else {
               var mktObj = {}
               mktObj['eventTypeName'] = mkt.eventTypeName;
               mktObj['competitionName'] = mkt.competitionName;
               mktObj['eventName'] = mkt.eventTypeId !== '300' ? mkt.eventName : mkt.eventName + ' ' + (mkt.marketType === 'WINNING_ODDS' ? 'LOTTERY' : mkt.marketType);
               mktObj['eventTypeId'] = mkt.eventTypeId;
               mktObj['eventId'] = mkt.eventId;
               mktObj['eventDate'] = !!this.state.eventDic[mkt.eventId] ? moment(this.state.eventDic[mkt.eventId].open_date).format('DD MMM YY') : ''; 
               mktObj['orderCount'] = mkt.orderCount;
               mktObj['pnl'] = mkt.pnl;
               mktObj['totalAmount'] = mkt.totalAmount;
               mktObj['markets'] = [];
               mktObj['markets'].push(mkt);
               filteredGroupedData.groupData[`k${mkt.eventId.toString()}`] = mktObj;
            }
            totatOrderCount += mkt.orderCount;
            totalPnl += mkt.pnl;
            totalStakes += mkt.totalAmount;
         }
      }
      filteredGroupedData.totatOrderCount = totatOrderCount;
      filteredGroupedData.totalPnl = totalPnl;
      filteredGroupedData.totalStakes = totalStakes;
      return filteredGroupedData;
   }
   
   onAction(e) {
      const eventPnL_data = this.filterEventPnLListWithGrouping()
      const name = e.target.name;
      if (name === "first") {
         this.setState({ pageActive: 1 })
      } else if (name === "prev") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }) ) 
      } else if (name === "next") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }) )
      } else if (name === "last") {
         this.setState({ action: name }, this.setState({ pageActive: Math.ceil( Object.keys(eventPnL_data.groupData).length / this.state.pageLimit)}) ) 
      } 
   }

   
   render() {
      const eventPnL_data = this.filterEventPnLListWithGrouping()
      const totatOrderCnt = eventPnL_data.totatOrderCount
      const ttlPnl = eventPnL_data.totalPnl
      const ttlStakes = eventPnL_data.totalStakes
      let totatDisplayOrderCount = 0
      let totalDisplayPnl = 0
      let totalDisplayStakes = 0
      let totatDisplayOrderCountPdf = 0
      let totalDisplayPnlPdf = 0
      let totalDisplayStakesPdf = 0

      let lst = []
      let total_page = Math.ceil( Object.keys(eventPnL_data.groupData).length/ this.state.pageLimit)
      for (let x = 1; x <= total_page; x++) {
         if (this.state.pageActive === x || Math.abs(x - this.state.pageActive) <= 2 || (this.state.pageActive < 3 && x < 6) || (total_page - this.state.pageActive < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.pageActive === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (x)} name="page_no" value={x} onClick={(e) => {{ this.onAction(e) } this.setState({ pageActive: x })}}>{x} </button>
            lst.push(htm)
         }
      }

      return (
         <>
            <div className="bethubs">
               <Header history={this.props.history} />
               <div className="wrapper">
                  <div className="container-fluid container-padding-0">
                     <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                           <div className="main-box">
                              <h5 className="text-blue">Event Profit & Loss Report</h5>
                              <div className="row mt-2">
                                 
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12 autocomplete-wrapper">
                                       <Autocomplete
                                          value={this.state.client_id}
                                          items={this.state.usersList}
                                          getItemValue={item => item.title}
                                          renderItem={(item, isHighlighted) =>
                                             <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                                {item.title}
                                             </div>
                                          }
                                          inputProps={{ placeholder: 'Search by client' }}
                                          name="client_id"
                                          onChange={(event, client_id) => this.onUserSearch(event, "client_id", client_id)}
                                          onSelect={client_id => this.setState({ client_id })}
                                       />
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12">
                                       <Datetime
                                          value={this.state.from}
                                          onChange={(e) => this.onDateTimeChange("from", e)}
                                          id="from_datetime"
                                          dateFormat={"DD/MM/YYYY"}
                                          timeFormat={"HH:mm"}
                                       />
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="form-group font-12">
                                       <Datetime
                                          value={this.state.to}
                                          onChange={(e) => this.onDateTimeChange("to", e)}
                                          id="to_datetime"
                                          dateFormat={"DD/MM/YYYY"}
                                          timeFormat={"HH:mm"}
                                       />
                                    </div>
                                 </div>
                                 <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                    <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                       <button className="btn btn-blue" onClick={(e) => this.onSubmit(e)}>Go</button>
                                       <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                    </div>
                                 </div>
                              </div>
                              {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}>Loading......</div> : null}
                              {!!this.state.showData && <div>

                                 
                                 <div className="row text-center mt-2">

                                    <div className="col-6 col-sm-6 col-md-3 col-lg-2 mt-1">
                                       <div className="">
                                          <div className="form-group mb-0 d-inline">
                                             <input className="form-control" name='search' value={this.state.search} onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-6 col-sm-6 col-md-3 col-lg-2 mt-1">
                                       <div className="form-group mb-0 font-12">
                                          <select title="Sport" className="form-control" name="sportType" value={this.state.sportType} onChange={(e) => { this.onChange(e) }}>
                                             <option value="">Select Sport</option>
                                             <option value="4">Cricket</option>
                                             <option value="1">Soccer</option>
                                             <option value="2">Tennis</option>
                                             <option value="7">Horse Racing</option>
                                             <option value="4339">Greyhound Racing</option>
                                             <option value="400">Kabaddi</option>
                                             <option value="500">Election</option>
                                             <option value="300">Binary</option>
                                             {/* <option value="99_LOTUS">Indian Poker</option> */}
                                             {/* <option value="99_SUPERNOVA">Indian Poker2</option> */}
                                             {/* <option value="99_DRC">Casino</option> */}
                                          </select>
                                       </div>
                                    </div>

                                      <CSVLink
                                          data={this.state.csv_json}
                                          filename={"Event P&L Report.csv"}
                                          asyncOnClick={true}
                                          className="d-none"
                                          ref={this.csvLink}>
                                       </CSVLink>
                                       <button className="btn btn-sm d-inline csv-icon p-0" title="Export Data" onClick={(e) => this.onDownload(false)} disabled={ Object.keys(eventPnL_data.groupData).length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                       
                                          <div style={{ display: "none" }}>
                                             <div id="printJS-div">
                                                <table id="exportall" className="table font-12 table-bordered table-sm" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px' }} >
                                                   <thead >
                                                      <tr>
                                                         <th className="pthead">SportType</th>
                                                         <th className="pthead">Competition</th>
                                                         <th className="pthead">Event</th>
                                                         <th className="text-right pthead">Order Count</th>
                                                         <th className="text-right pthead">Total Amount</th>
                                                         <th className="text-right pthead">P/L</th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                   {!!this.state.loader ?
                                                   <tr>
                                                      <td colSpan={15} align="center">
                                                         Loading......
                                                    </td>
                                                   </tr> :
                                                   Object.keys(eventPnL_data.groupData).length > 0 ? 
                                                   <>
                                                     
                                                      <tr bgcolor="#ffffff" key={"GTotal"}>
                                                         <td colSpan={3} className="text-right"><b>Grand Total (All Records)</b></td>
                                                         <td className="text-right"><b>{totatOrderCnt}</b></td>
                                                         <td className="text-right"><Currency key={"totalstakes"} className={!!ttlStakes && ttlStakes < 0 ? "fbold text-red" :"fbold text-green"} amount={ttlStakes} showColor={false} /></td>
                                                         <td className="text-right"><Currency key={"totalpnl"} className={!!ttlPnl && ttlPnl < 0 ? "fbold text-red" :"fbold text-green"} amount={ttlPnl} showColor={false} /></td>
                                                       </tr>
                                                      {Object.keys(eventPnL_data.groupData).map((evnt_key, i) => {

                                                         if(this.state.allData ? "" : i >= (this.state.pageLimit * this.state.pageActive) || (i + 1) <= (this.state.pageLimit * (this.state.pageActive - 1))){
                                                            return false
                                                         }
                                                         const evnt_itm = eventPnL_data.groupData[evnt_key]
                                                       
                                                         totatDisplayOrderCountPdf += evnt_itm.orderCount
                                                         totalDisplayPnlPdf += evnt_itm.pnl
                                                         totalDisplayStakesPdf += evnt_itm.totalAmount
                                                       
                                                         let competitionName = evnt_itm.competitionName ? (evnt_itm.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(evnt_itm.competitionName) : evnt_itm.competitionName) : "-"
                                                         return (<>
                                                            {this.state.allData ? 
                                                              
                                                               <tr bgcolor="#ffffff" key={i}>
                                                                 <td title={evnt_itm.eventTypeName}>{evnt_itm.eventTypeName}</td>
                                                                 <td>{competitionName}</td> 
                                                                 <td title={evnt_itm.eventName}><a className="undline" onClick={(e) => this.onShowOrderPopup(evnt_itm.markets, evnt_itm.pnl, evnt_itm.totalAmount, evnt_itm.orderCount)} >{evnt_itm.eventId} - {evnt_itm.eventName} - {evnt_itm.eventDate}</a></td>
                                                                 <td className="text-right">{evnt_itm.orderCount}</td>
                                                                 <td className="text-right"><Currency key={"stakes_" + i} className={!!evnt_itm.totalAmount && parseFloat(evnt_itm.totalAmount) < 0 ? "fbold text-red" :"fbold text-green"} amount={evnt_itm.totalAmount} showColor={false} /></td>
                                                                 <td className="text-right"><Currency key={"pnl_" + i} className={!!evnt_itm.pnl && parseFloat(evnt_itm.pnl) < 0 ? "fbold text-red" :"fbold text-green"} amount={evnt_itm.pnl} showColor={false} /></td>
                                                              </tr>
                                                            
                                                             : i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) &&
                                                            <tr bgcolor="#ffffff" key={i}>
                                                               <td title={evnt_itm.eventTypeName}>{evnt_itm.eventTypeName}</td>
                                                               <td>{competitionName}</td> 
                                                               <td title={evnt_itm.eventName}><a className="undline" onClick={(e) => this.onShowOrderPopup(evnt_itm.markets, evnt_itm.pnl, evnt_itm.totalAmount, evnt_itm.orderCount)} >{evnt_itm.eventId} - {evnt_itm.eventName} - {evnt_itm.eventDate}</a></td>
                                                               <td className="text-right">{evnt_itm.orderCount}</td>
                                                               <td className="text-right"><Currency key={"stakes_" + i} className={!!evnt_itm.totalAmount && parseFloat(evnt_itm.totalAmount) < 0 ? "fbold text-red" :"fbold text-green"} amount={evnt_itm.totalAmount} showColor={false} /></td>
                                                               <td className="text-right"><Currency key={"pnl_" + i} className={!!evnt_itm.pnl && parseFloat(evnt_itm.pnl) < 0 ? "fbold text-red" :"fbold text-green"} amount={evnt_itm.pnl} showColor={false} /></td>
                                                            </tr>
                                                            }
                                                            </>
                                                         );
                                                      })}
                                                      <tr bgcolor="#ffffff" key={"Total"}>
                                                         <td colSpan={3} className="text-right"><b>Total (Display Records)</b></td>
                                                         <td className="text-right"><b>{totatDisplayOrderCountPdf}</b></td>
                                                         <td className="text-right"><Currency key={"totalstakes"} className={!!totalDisplayStakesPdf && totalDisplayStakesPdf < 0 ? "fbold text-red" :"fbold text-green"} amount={totalDisplayStakesPdf} showColor={false} /></td>
                                                         <td className="text-right"><Currency key={"totalpnl"} className={!!totalDisplayPnlPdf && totalDisplayPnlPdf < 0 ? "fbold text-red" :"fbold text-green"} amount={totalDisplayPnlPdf} showColor={false} /></td>
                                                      </tr>
                                                   </>
                                                   : <tr>
                                                      <td colSpan={15} align="center"> No Data Found. </td>
                                                     </tr>
                                                     }

                                                   </tbody>
                                                </table>
                                             </div>
                                          </div>

                                       <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(false)} disabled={ Object.keys(eventPnL_data.groupData).length > 0 ? false : true}> <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img></button>
                                       <button className="btn btn-sm d-inline csv-icon-all p-0 mx-2" title="Export All Data" onClick={(e) => this.onDownload(true)} disabled={ Object.keys(eventPnL_data.groupData).length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon-all.svg`}></img></button>
                                       <button className="btn btn-sm pdf-icon-all d-inline p-0" title="Export All Data" onClick={(e) => this.onPDFDownload(true)} disabled={ Object.keys(eventPnL_data.groupData).length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon-all.svg`}></img> </button>
                                      
                                      <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                          <span className="d-inline search-report"> &nbsp; entries</span>
                                          <div className="form-group font-12 float-right mb-0">
                                             <select onKeyPress={(e) => this.onAction(e)} onChange={(e) => { this.onChange(e) }} className="form-control" name="pageLimit" value={this.state.pageLimit}>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                                <option value="500">500</option>
                                             </select>
                                           </div>
                                           <span className="d-inline search-report mr-2">Show</span>
                                     </div>
      
                                 </div>

                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                       <div className="table-responsive">
                                          <table id="example" className="table font-12 table-bordered table-sm addpadding table-striped mt-2">
                                             <thead>
                                                <tr>
                                                   <th className="pthead">SportType</th>
                                                   <th className="pthead">Competition</th>
                                                   <th className="pthead">Event</th>
                                                   <th className="text-right pthead">Order Count</th>
                                                   <th className="text-right pthead">Total Amount</th>
                                                   <th className="text-right pthead">P/L</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                {!!this.state.loader ?
                                                   <tr>
                                                      <td colSpan={15} align="center">
                                                         Loading......
                                                    </td>
                                                   </tr> :
                                                   Object.keys(eventPnL_data.groupData).length > 0 ? 
                                                   <>

                                                     <tr bgcolor="#ffffff" key={"GTotal"}>
                                                         <td colSpan={3} className="text-right"><b>Grand Total (All Records)</b></td>
                                                         <td className="text-right"><b>{totatOrderCnt}</b></td>
                                                         <td className="text-right"><Currency key={"totalstakes"} className={!!ttlStakes && ttlStakes < 0 ? "fbold text-red" :"fbold text-green"} amount={ttlStakes} showColor={false} /></td>
                                                         <td className="text-right"><Currency key={"totalpnl"} className={!!ttlPnl && ttlPnl < 0 ? "fbold text-red" :"fbold text-green"} amount={ttlPnl} showColor={false} /></td>
                                                      </tr>
                                                      {Object.keys(eventPnL_data.groupData).map((evnt_key, i) => {
                                                         
                                                         if( ( i >= (this.state.pageLimit * this.state.pageActive) || (i + 1 ) <= (this.state.pageLimit * (this.state.pageActive - 1))) ){
                                                            return false
                                                         }
                                                         const evnt_itm = eventPnL_data.groupData[evnt_key]
                                                       
                                                         totatDisplayOrderCount += evnt_itm.orderCount
                                                         totalDisplayPnl += evnt_itm.pnl
                                                         totalDisplayStakes += evnt_itm.totalAmount
                                                      
                                                         let competitionName = evnt_itm.competitionName ? (evnt_itm.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(evnt_itm.competitionName) : evnt_itm.competitionName) : "-"
                                                         return (<>
                                                            {/* {i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) && */}
                                                            <tr key={i}>
                                                               <td title={evnt_itm.eventTypeName}>{evnt_itm.eventTypeName}</td>
                                                               <td>{competitionName}</td> 
                                                               <td title={evnt_itm.eventName}><a className="undline" onClick={(e) => this.onShowOrderPopup(evnt_itm.markets, evnt_itm.pnl, evnt_itm.totalAmount, evnt_itm.orderCount)} >{evnt_itm.eventId} - {evnt_itm.eventName} - {evnt_itm.eventDate}</a></td>
                                                               <td className="text-right">{evnt_itm.orderCount}</td>
                                                               <td className="text-right"><Currency key={"stakes_" + i} className={!!evnt_itm.totalAmount && parseFloat(evnt_itm.totalAmount) < 0 ? "fbold text-red" :"fbold text-green"} amount={evnt_itm.totalAmount} showColor={false} /></td>
                                                               <td className="text-right"><Currency key={"pnl_" + i} className={!!evnt_itm.pnl && parseFloat(evnt_itm.pnl) < 0 ? "fbold text-red" :"fbold text-green"} amount={evnt_itm.pnl} showColor={false} /></td>
                                                            </tr>
                                                                                             
                                                            {/* } */}
                                                            </>
                                                         );
                                                      })}
                                                      <tr bgcolor="#ffffff" key={"Total"}>
                                                         <td colSpan={3} className="text-right"><b>Total (Display Records)</b></td>
                                                         <td className="text-right"><b>{totatDisplayOrderCount}</b></td>
                                                         <td className="text-right"><Currency key={"totalstakes"} className={!!totalDisplayStakes && totalDisplayStakes < 0 ? "fbold text-red" :"fbold text-green"} amount={totalDisplayStakes} showColor={false} /></td>
                                                         <td className="text-right"><Currency key={"totalpnl"} className={!!totalDisplayPnl && totalDisplayPnl < 0 ? "fbold text-red" :"fbold text-green"} amount={totalDisplayPnl} showColor={false} /></td>
                                                      </tr>
                                                      
                                                   </>
                                                   : <tr>
                                                       <td colSpan={15} align="center"> No Data Found.</td>
                                                     </tr>}
                                             </tbody>
                                          </table>
                                       </div>
                                       
                                       {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                                    </div>
                                 </div>
                              </div>}
                              
                              { 
                                 Object.keys(eventPnL_data.groupData).length > 0 &&
                              <>       
                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) <  Object.keys(eventPnL_data.groupData).length ? (this.state.pageLimit * this.state.pageActive) :  Object.keys(eventPnL_data.groupData).length} of { Object.keys(eventPnL_data.groupData).length} entries</span></div>
                                    <div className="col-12 col-sm-12 col-md-6">
                                       <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>First</button>
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>Prev</button>
                                          {lst}  
                                          <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil( Object.keys(eventPnL_data.groupData).length / this.state.pageLimit)? true : false}>Next</button>
                                          <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil( Object.keys(eventPnL_data.groupData).length / this.state.pageLimit)? true : false}>Last</button>
                                       </div>
                                    </div>
                                 </div>
                              </>
                           }

                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <Footer />
               {this.state.onShowOrderPopup && <EventPnLReportMarketOrderModel user_id={this.state.client_id} current_user={this.state.user_id} selectedMarketList={this.state.selectedMarketList} hidePopupBets={() => { this.onHideOrderPopup() }} />}
            </div>
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(EventPnLReport);